import { default as Msg } from '@/i18n/components/FormattedMessage';

export const OverviewTab = () => {
  return (
    <div data-testid='overviewTab' className='grid grid-flex grid-justify-center' style={{ maxWidth: '500px' }}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.magentaTv.modal.overview.paragraph1'
          defaultMessage='Ob TV, Smartphone, Tablet oder Laptop: Erlebe mit MagentaTV Flex Fernsehen & Streaming überall und jederzeit. Für Dich jetzt mit 15% Rabatt*'
        />
      </div>

      <ul data-testid='bullets' className='list-check list-spacing-s'>
        <li>
          <Msg
            id='benefits.magentaTv.modal.overview.bullet1'
            defaultMessage='Große Sendervielfalt mit über 160 HD-Sendern'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.overview.bullet2'
            defaultMessage='Filme und Serien bei MagentaTV+ inklusive'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.overview.bullet3'
            defaultMessage='Mehr Komfort dank Restart, Timeshift oder Aufnahmefunktion'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.overview.bullet4'
            defaultMessage='Streamingdienste wie z.B. Netflix oder Disney+ zubuchbar'
          />
        </li>
        <li>
          <Msg
            id='benefits.magentaTv.modal.overview.bullet5'
            defaultMessage='Nur 8,50€ mtl., monatlich kündbar, nutzbar an jedem Internetanschluss'
          />
        </li>
      </ul>
      <div className='padding-top-l one-whole display-flex align-left'>
        <Msg id='benefits.magentaTv.modal.overview.starredInfo' defaultMessage='* Es gelten die Nutzungsbedingungen.' />
      </div>
    </div>
  );
};
